import React, { useState, useEffect } from "react";
import { Quiz } from "../../@types/quiz.interfaces";
import "./view-quiz.styles.scss";
import { useHistory } from "react-router-dom";
import DeletePrompt from "../delete-prompt/delete-prompt.component";
import Loading from "../loading/loading.component";
import InputFilter from "../input-filter/input-filter.component";
import DataTable from "react-data-table-component";
import { EditOutlineIcon } from "../icons/edit/edit.component";
import { TrashOutlineIcon } from "../icons/trash/trash.component";

interface IProps {
    quizzes: Quiz[] | null;
}

interface data {
    no: number;
    course_name: string;
    quiz_duration: string;
    created_at: Date | undefined;
    created_by: string | undefined;
    action: Element | JSX.Element;
}

export default function ViewQuiz({ quizzes }: IProps) {
    const history = useHistory();
    const [data] = useState<data[]>([]);
    const [isFetching, setIsFetching] = useState<boolean>(true);

    useEffect(() => {
        if (quizzes !== null) {
            for (let index = 0; index < quizzes.length; index++) {
                data.push({
                    no: index + 1,
                    course_name: quizzes[index].courses.course_name,
                    quiz_duration: quizzes[index].quiz_duration + " minutes",
                    created_at: quizzes[index].created_at,
                    created_by: quizzes[index].users?.name
                        ? quizzes[index].users?.name
                        : quizzes[index].users?.initial,
                    action: (
                        <div className="flex-row-space-between">
                            <EditOutlineIcon
                                size={1.8}
                                onClick={() =>
                                    history.push(
                                        `/quiz/${quizzes[index].quiz_id}`
                                    )
                                }
                            />
                            <TrashOutlineIcon
                                hoverColor="red"
                                size={1.7}
                                onClick={() =>
                                    handleDelete(quizzes[index].quiz_id)
                                }
                            />
                        </div>
                    ),
                });
            }
            setIsFetching(false);
        }
    }, [quizzes, data, history]);

    const columns = [
        {
            name: "No",
            selector: "no",
            sortable: true,
            width: "50px",
        },
        {
            name: "Course",
            selector: "course_name",
            sortable: true,
        },
        {
            name: "Duration",
            selector: "quiz_duration",
            sortable: true,
        },
        {
            name: "Created At",
            selector: "created_at",
            sortable: true,
        },
        {
            name: "Created By",
            selector: "created_by",
            sortable: true,
        },
        {
            name: "Actions",
            selector: "action",
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: "16px",
            },
        },
        rows: {
            style: {
                fontSize: "16px",
            },
        },
        pagination: {
            style: {
                fontSize: "16px",
                fontWeight: 600,
            },
        },
    };

    const [filterData, setFilterData] = useState<data[]>(data);
    const [val, setVal] = useState<string>("");
    const onHandleChange = (evt: any) => {
        let filterText = evt.target.value;
        if (filterText !== "") {
            setFilterData(
                data.filter(
                    (quiz) =>
                        quiz.course_name &&
                        quiz.course_name
                            .toLowerCase()
                            .includes(filterText.toLowerCase())
                )
            );
        } else setFilterData(data);
        setVal(filterText);
    };

    const onClear = () => {
        setFilterData(data);
        setVal("");
    };

    const [deleteState, setDeleteState] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<number>(-1);
    const handleDelete = (id: number | undefined) => {
        setDeleteState(true);
        if (id !== undefined) setDeleteId(id);
    };

    return (
        <div className="view-quiz">
            {deleteState ? (
                <DeletePrompt
                    quizId={deleteId}
                    deleteState={deleteState}
                    setDeleteState={setDeleteState}
                    quiz
                />
            ) : (
                ""
            )}
            <div className="title">
                <h2 className="heading">View Quiz</h2>
            </div>
            <div className="view-quiz__detail">
                {isFetching ? (
                    <Loading />
                ) : (
                    <div className="view-quiz__detail__table">
                        <InputFilter
                            classNames="view-quiz__detail__table__filter"
                            value={val}
                            onFilter={onHandleChange}
                            onClear={onClear}
                        />

                        <DataTable
                            className="scrollbar"
                            columns={columns}
                            data={filterData}
                            customStyles={customStyles}
                            noHeader
                            responsive
                            pagination
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
